module.exports = __webpack_public_path__ + "media/02.b2ffe760.wav";